import { useSearchableTabs } from '@hook'
import { Tab2, TitleHeader } from '@ui'
import { UnitDose } from './Inpatient/UnitDose'
import PrescriptionFill from './PrescriptionFill'

const tabs = [
  { label: 'Unit Dose (UDDS)', value: 'unit_dose' },
  // { label: 'Unit of Use (UoU)', value: 'unit_use' },
  { label: 'Standard Inpatient Fills', value: 'inpatient_fill' }
  // { label: 'Bulk/Floor Stock/Order', value: 'bulk_order' },
  // { label: 'M.A.R', value: 'mar' },
  // { label: 'Medication Returns', value: 'medication_return' }
]
export const Inpatient = () => {
  const { activeTab, setActiveTab } = useSearchableTabs({ defaultValue: 'unit_dose' })
  return (
    <div className="flex flex-col flex-1 bg-white overflow-auto gap-5 min-w-0">
      <TitleHeader title="In-patients" />
      <div className="flex justify-start overflow-x-auto">
        <Tab2 activeTab={activeTab} background="#ffff99" setActiveTab={setActiveTab} tabs={tabs} />
      </div>
      <div className="flex flex-col overflow-auto min-w-0">
        {activeTab === 'unit_dose' && <UnitDose />}
        {/* {activeTab === 'unit_use' && <UnitUse />} */}
        {activeTab === 'inpatient_fill' && <PrescriptionFill prescriptionType="inpatient" />}
      </div>
    </div>
  )
}

export default Inpatient
